module.exports = __webpack_public_path__ + "img/pic-leaf.e7c4cb8.svg";